const pastShows = [
  {
    id: 1,
    slug: "fox-theater-salinas-2024",
    position: [36.6777, -121.6555],
    venue: "Fox Theater",
    city: "Salinas, CA",
    date: "2024-08-15",
    packageType: "Public Concert",
    images: [
      "/assets/images/placeholder-gallery-1.jpg",
      "/assets/images/placeholder-gallery-2.jpg",
      "/assets/images/placeholder-gallery-3.jpg",
      "/assets/images/placeholder-gallery-4.jpg",
      "/assets/images/placeholder-gallery-5.jpg",
      "/assets/images/placeholder-gallery-6.jpg",
    ],
  },
  {
    id: 2,
    slug: "el-rey-theatre-la-2024",
    position: [34.0522, -118.2437],
    venue: "El Rey Theatre",
    city: "Los Angeles, CA",
    date: "2024-07-20",
    packageType: "Public Concert",
    images: [
      "/assets/images/placeholder-gallery-1.jpg",
      "/assets/images/placeholder-gallery-2.jpg",
      "/assets/images/placeholder-gallery-3.jpg",
      "/assets/images/placeholder-gallery-4.jpg",
      "/assets/images/placeholder-gallery-5.jpg",
      "/assets/images/placeholder-gallery-6.jpg",
    ],
  },
  {
    id: 3,
    slug: "private-party-san-antonio-2024",
    position: [29.4241, -98.4936],
    venue: "Private Party",
    city: "San Antonio, TX",
    date: "2024-05-10",
    packageType: "Private Party",
    images: [
      "/assets/images/placeholder-gallery-1.jpg",
      "/assets/images/placeholder-gallery-2.jpg",
      "/assets/images/placeholder-gallery-3.jpg",
      "/assets/images/placeholder-gallery-4.jpg",
      "/assets/images/placeholder-gallery-5.jpg",
      "/assets/images/placeholder-gallery-6.jpg",
    ],
  },
  {
    id: 4,
    slug: "the-van-buren-phoenix-2024",
    position: [33.4484, -112.074],
    venue: "The Van Buren",
    city: "Phoenix, AZ",
    date: "2024-05-12",
    packageType: "Public Concert",
    images: [
      "/assets/images/placeholder-gallery-1.jpg",
      "/assets/images/placeholder-gallery-2.jpg",
      "/assets/images/placeholder-gallery-3.jpg",
      "/assets/images/placeholder-gallery-4.jpg",
      "/assets/images/placeholder-gallery-5.jpg",
      "/assets/images/placeholder-gallery-6.jpg",
    ],
  },
];

export default pastShows;
